module.exports = __webpack_public_path__ + "media/8an-turkey.7a16e6f7.mp3";